import React, { Component } from 'react';
//import axios from 'axios'

//reactstrap
import { Container, Row, Col, Input, InputGroupAddon, InputGroup, Button} from 'reactstrap';

import { Link } from 'react-router-dom';

//imagen
import Logobn from '../../Img/logo/portaprent-1.png';

//icon
import stand from '../../Img/icon/stand.svg';
import backing from '../../Img/icon/backing.svg';
import impresion from '../../Img/icon/impresion.svg';

//axios
import axios from 'axios';

//style
import './Footer.scss';

export class Footer extends Component {
  constructor(){
  super()
    this.onChangeCorreo = this.onChangeCorreo.bind(this);
    this.handleSubmitCorreo = this.handleSubmitCorreo.bind(this);
    this.state = {
      Message: '',
      value: '',
      correo:''
    }
    this.handleMessageInput = this.handleMessageInput.bind(this);
  }
    handleMessageInput (e){
      this.setState({Messages: e.target.value})
    }
    onChangeCorreo(e){
      console.log("enviado datos");
      this.setState({ correo: e.target.value});
    }
    handleSubmitCorreo(e){
      e.preventDefault()
      console.log('voy aca')
      const correoObect ={
        correo: this.state.correo
      };
      axios.post('http://localhost:4000/api/', correoObect)
        .then((res) => {
            console.log(res.data)
        }).catch((error) => {
            console.log(error)
        });
      this.setState({correo:''})
    }

  render() {
    return (
      <div className={"Footer-encabezado"}>
          <Container>
            <Row className={'FooterLogo'} >
            </Row>
            <Row className={'FooterOption'}>
                <Col lg="3" md="3" sm="12" xs="12" className={"logo-b-n"} >
                  <a href="">
                    <img src={Logobn} alt="logo blanco y negro" className={"logob-n"}/>
                  </a>
                </Col>
                <Col lg="3" md="3" sm="4" xs="12" className={"redes-Sociales"} >
                    <h4>nuestras redes</h4>
                    <h6><i className="fab fa-instagram"></i><a href="https://www.instagram.com/portaprent/" target="_blank" rel='noreferrer noopener'> Instagram</a></h6>
                    <h6><i className="fab fa-facebook-f" ></i><a href="https://www.facebook.com/portaprent" target="_blank" rel='noreferrer noopener'> Facebook</a></h6>
                    <h6><i className="fab fa-linkedin-in"></i><a href="https://www.linkedin.com/company/portaprent/" target="_blank" rel='noreferrer noopener'> Linkedin</a></h6>
                    <h6><i className="fab fa-twitter"></i><a href="https://twitter.com/portaprent" target="_blank" rel='noreferrer noopener'> Twitter</a></h6>
                </Col>
                <Col lg="3" md="3" sm="4" xs="12" className={"Nuestros-Proyectos"} >
                  <h4>Nuestros Proyectos</h4>
                  <h6 title="Impresion Digital" ><img src={impresion} className={"iconFooter"} alt="Impresion Digital" /> Impresion Digital</h6>
                  <h6 title="Backing" ><img src={backing} className={"iconFooter"} alt="Backing" /> Backing</h6>
                  <h6 title="Stand" ><img src={stand} className={"iconFooter"} alt="stand"/> Stand</h6>
                </Col>
                <Col lg="3" md="3" sm="4" xs="12" className={"Recibir-Inf"} >
                  <h4>Recibe Información</h4>
                  <h6>Cel:</h6>
                  <h6>321-410-1344 - 313-217-6132</h6>
                  <h6><a href="mailto:portaprent@correo.com">jhonatancasas836@gmail.com</a></h6>
                  <InputGroup className={"InputFooter"}>
                    <InputGroupAddon addonType="prepend">@</InputGroupAddon>
                    <Input type="email" value={this.state.correo} onChange={this.onChangeCorreo} name="uno" plasholder="Contactame"/>
                    <Button type="submit" value="Enviar" onClick={this.handleSubmitCorreo} >Enviar</Button>
                  </InputGroup>
                </Col>
            </Row>
            <Row className={'terminosOption'}>
              <Col lg="3" className={"colContainer"} >
                <Link to="/Terminos-Condiciones" className={"terminos"} >Terminos y condiciones</Link>
                {/* <Link to="/Politicas">politicas </Link> */}
              </Col>
            </Row>
          </Container>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx